import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useTimezone } from './useTimezone.js';
import { Typeahead } from '../Typeahead/Typeahead.js';

var Timezone = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? "Select Timezone" : _b, props = __rest(_a, ["placeholder"]);
    var timezones = useTimezone();
    return (jsx(Typeahead, __assign({ placeholder: placeholder, suggestions: timezones }, props)));
};
Timezone.displayName = "Timezone";

export { Timezone };
//# sourceMappingURL=Timezone.js.map
